import { Actions } from "../table/table.actions"
import createTableReducer, { DEFAULT_STATE } from "../table/table.reducer"

const INITIAL_STATE = {
  ...DEFAULT_STATE,
  sorting: ["full_name=asc"],
  defaultSorting: ["full_name=asc", "balance_hours=desc", "planned_hours=desc"],
}

const planningAvailabilitiesTableReducer = (state = INITIAL_STATE, action: Actions) =>
  createTableReducer("PLANNING_WEEK_AVAILABILITIES_TABLE", {})(state, action)

export default planningAvailabilitiesTableReducer
